export default __webpack_public_path__ + "static/media/54.d20f8fd4.png";